.wrap {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

.pad {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 5px;
}

.pad button {
  /* >= 44px on touch, per the handoff's hit-target rule. */
  min-height: 44px;
  padding: 0;
}

.recentre {
  color: var(--color-accent);
  border-color: var(--color-accent);
}

.hint {
  margin: 0;
  font-size: 11px;
  color: rgb(233 233 237 / 0.35);
  text-align: center;
}

@media (min-width: 900px) {
  .pad button {
    min-height: 34px;
  }
}
